var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkdinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 5.5,
    fill: "#0076B2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 5.5,
    stroke: "#E0E0E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.27 21.4375H19.6656V32.3631H16.27V21.4375ZM17.9688 16C18.3582 16 18.7389 16.1155 19.0627 16.3319C19.3865 16.5483 19.6389 16.8559 19.7878 17.2158C19.9368 17.5756 19.9756 17.9716 19.8995 18.3535C19.8234 18.7355 19.6357 19.0863 19.3602 19.3615C19.0847 19.6368 18.7337 19.8241 18.3517 19.8999C17.9697 19.9757 17.5738 19.9364 17.214 19.7871C16.8543 19.6378 16.547 19.3852 16.3309 19.0612C16.1148 18.7372 15.9996 18.3563 16 17.9669C16.0005 17.4451 16.2081 16.9448 16.5773 16.576C16.9465 16.2072 17.4469 16 17.9688 16ZM21.7956 21.4375H25.0506V22.9375H25.0956C25.5494 22.0787 26.6556 21.1731 28.3075 21.1731C31.7463 21.1656 32.3838 23.4287 32.3838 26.3631V32.3631H28.9881V27.0475C28.9881 25.7819 28.9656 24.1525 27.2238 24.1525C25.4819 24.1525 25.1856 25.5325 25.1856 26.965V32.3631H21.7956V21.4375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdinIcon);
export default __webpack_public_path__ + "static/media/linkdin-icon.3cf5ede33a0e2fc1f2f5f72728482ce1.svg";
export { ForwardRef as ReactComponent };